export enum QuotesRFQApi {
  ExportPDF = '/quote/:quoteId/rfq-export-pdf',
  PreviewPDF = '/quote/:quoteId/rfq-export-preview',
  Get = '/quote/:quoteId',
  UpdateProfilePhoto = '/quote/:quoteId/uploadProfileImage',
  UpdatePreviewInfo = '/quote/:quoteId/previewInfo',
  Update = '/quote/:quoteId/edit-quote'
}
